import React from "react";
import { FaCheckCircle } from "react-icons/fa";
import UserContext from "../../UserContext";
import { containsOnlyEmojis, removeSpaces } from "../../utils/global-functions";
import { url } from "../../utils/url";

import UserProfile from "../../images/avatar-defaul-girls.jpg";
export default function MessagesComponent({
  messages = [],
  chat = {},
  loadingMessages,
}) {
  const { user } = React.useContext(UserContext);
  const scrollToBottom = () => {
    let el = document.getElementsByClassName("messages-list");
    el[0].scrollTo({
      behavior: "auto",
      left: 0,
      top: 10000000,
    });
  };

  const emojiClasses = (message) => {
    return containsOnlyEmojis(message) ? "emoji-message" : "";
  };

  React.useEffect(() => {
    scrollToBottom();
  }, [messages]);

  
  return (
    <div className="messages-list px-2 ml-2">
      {messages.length === 0 && (
        <div className="mt-20">
          {loadingMessages ? (
            <p>Loading conversations...</p>
          ) : (
            <p>
              This is the beginning of the conversation between <b>you</b> and{" "}
              <b>{chat.username}</b>
            </p>
          )}
        </div>
      )}
      {messages.map((message, index) => (
        <div key={message._id}>
          {message.to?._id === user.info?._id ? (
            <div
              className={
                message.to?._id === messages[index + 1]?.to?._id ||
                index === messages.length - 1
                  ? `to-message message flex gap-3 items-center mb-1 ${emojiClasses(
                      message.message
                    )}`
                  : `to-message message flex gap-3 items-center mb-3 ${emojiClasses(
                      message.message
                    )}`
              }
            >
              {message.to?._id !== messages[index - 1]?.to?._id ? (
                <img
                  src={
                    message.from?.image
                    ? message.from?.image
                    : url + message.from?.profile?.url || UserProfile
                  }
                  alt={message.to?.username}
                  className="object-cover"
                  style={{ width: "30px", height: "30px", borderRadius: "50%" }}
                ></img>
              ) : (
                <div
                  style={{ width: "30px", height: "30px", borderRadius: "50%" }}
                ></div>
              )}
              <div className="content">
                {containsOnlyEmojis(message.message)
                  ? removeSpaces(message.message)
                  : message.message}
              </div>
            </div>
          ) : (
            <div
              className={
                message.from?._id === messages[index + 1]?.from?._id ||
                index === messages.length - 1
                  ? `from-message message flex gap-1 mb-1 justify-end ${emojiClasses(
                      message.message
                    )}`
                  : `from-message message flex gap-1 mb-3 justify-end  ${emojiClasses(
                      message.message
                    )}`
              }
            >
              <div className="content-container">
                <div className="content">
                  {containsOnlyEmojis(message.message)
                    ? removeSpaces(message.message)
                    : message.message}
                </div>
                {index === messages.length - 1 && message.status === "read" && (
                  <p style={{ float: "right" }} className="mr-2 text-gray-500">
                    seen
                  </p>
                )}
                {message._id === "123456789" && (
                  <p style={{ float: "right" }} className="mr-2 text-gray-500">
                    sending...
                  </p>
                )}
              </div>
              <div className="w-3 h-3 mt-1">
                {message.status === "read" && (
                  <FaCheckCircle
                    title="seen"
                    className="w-full h-full text-gray-300 mt-2"
                  ></FaCheckCircle>
                )}
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
